'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175() {
  this.cga = null;
  this.cg8 = null;
  this.cg9 = false;
  this.cg6 = null;
  this.cg7 = false;
  this.cgb = false;
  this.cgc = false;
  this.cga = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175 as $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175 };
$p = $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175;
/** @constructor */
function $h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175() {
}
export { $h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175 as $h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175 };
$h_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.cga;
});
$p.t = (function() {
  if ((!this.cg9)) {
    this.cg8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("secret", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cg9 = true;
  }
  return this.cg8;
});
$p.ag = (function() {
  if ((!this.cg7)) {
    this.cg6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cg7 = true;
  }
  return this.cg6;
});
$p.v = (function() {
  if ((!this.cgc)) {
    this.cgb = false;
    this.cgc = true;
  }
  return this.cgb;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175, "presto.types$proto$StoreTwoFactorAuthRequestPayload$$anon$175", ({
  a3L: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175 as $d_Lpresto_types$proto$StoreTwoFactorAuthRequestPayload$$anon$175 };
//# sourceMappingURL=presto.types$proto$-Store-Two-Factor-Auth-Request-Payload$$anon$175.js.map
